import { render, staticRenderFns } from "./CustomerFeedback.vue?vue&type=template&id=e70a30ba&scoped=true"
import script from "./CustomerFeedback.vue?vue&type=script&lang=js"
export * from "./CustomerFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70a30ba",
  null
  
)

export default component.exports